<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Transportation Reports </b-navbar-brand>
          <!-- <b-button class="pull-right ml-5"  size="sm"  @click="downloadDocs">Download Docs</b-button> -->
          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-form-input
                class="mr-sm-2"
                v-model="filter"
                @input="viewFFExportFCL('0','1')"
                placeholder="Search"
              ></b-form-input>
          
            </b-nav-form>
          </b-navbar-nav>-->
        </b-navbar>
        <div>
          <b-card no-body>
            <b-tabs pills card vertical>
              <b-tab title="TPT Dashboard" active
                ><b-card-text
                  >TPT Dashboard Content will come here</b-card-text
                ></b-tab
              >
              <b-tab title="Reports"
                ><b-card-text class="mt-3">
                  <b-row class="mt-4">
                    <b-col md="8" offset-md="2">
                      <label
                        class="mr-sm-2"
                        for="inline-form-custom-select-pref"
                        >Client Name</label
                      >
                      <model-list-select
                        :list="clientMaster"
                        id="clientNamenew"
                        v-model="clientIdFilter"
                        option-value="clientId"
                        option-text="clientName"
                        placeholder="Select  Client Name"
                      >
                      </model-list-select
                    ></b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <!-- :maxDate="maxDate" -->
                    <b-col md="8" offset-md="2">
                      <label
                        class="mr-sm-2"
                        for="inline-form-custom-select-pref"
                        >Date Range</label
                      ><date-range-picker
                        :always-show-calendars="showCal"
                        ref="picker"
                        opens="right"
                        :locale-data="locale"
                        v-model="dateRange"
                      >
                        <div slot="input" slot-scope="picker">
                          {{ dateRange.startDate | moment }} -
                          {{ dateRange.endDate | moment }}
                        </div>
                      </date-range-picker>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <!-- :maxDate="maxDate" -->
                    <b-col>
                      <b-row class="justify-content-center">
                      <!-- <div>
                        <b-button
                          @click="getReports('GR_TRACKING_REPORT')"
                          class="mr-2"
                          variant="outline-primary"
                          >GR Tracking Report</b-button
                        >
                      </div> -->

                      <b-button
                        class="ml-1"
                        :disabled="ExcelBtnName != 'GR Tracking Report' ? true : false"
                        @click="getReports('GR_TRACKING_REPORT', 'GR Tracking Report')"
                        size="sm"
                        variant="warning"
                        > {{ ExcelBtnName }}
                        <b-spinner
                          v-if="ExcelBtnName != 'GR Tracking Report'"
                          small
                          label="Small Spinner"
                        ></b-spinner
                      ></b-button>

                      <!-- <div>
                        <b-button
                          @click="getReports('TRUCKING_ANALYSIS_REPORT')"
                          variant="outline-primary"
                          >TPT Trucking Analysis Report</b-button
                        ></div
                      > -->
                      <b-button
                        class="ml-1"
                        :disabled="ExcelBtnTPTName != 'TPT Trucking Analysis Report' ? true : false"
                        @click="getReports('TRUCKING_ANALYSIS_REPORT', 'TPT Trucking Analysis Report')"
                        size="sm"
                        variant="warning"
                        > {{ ExcelBtnTPTName }}
                        <b-spinner
                          v-if="ExcelBtnTPTName != 'TPT Trucking Analysis Report'"
                          small
                          label="Small Spinner"
                        ></b-spinner
                      ></b-button>
                       </b-row>
                    </b-col>
                  </b-row>
                </b-card-text></b-tab
              >
              <!-- <b-tab title="Tab 3"><b-card-text>Tab contents 3</b-card-text></b-tab> -->
            </b-tabs>
          </b-card>
        </div>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="PopDoc"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/listView/viewAssignmentOrder");
      this.$sessionsStorage.set(
        "PermissionStatus",
        globalPermissionStatus("QuotationAssignment")
      );
      this.viewAssignment("0", "1", "1");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "GR Tracking Report",
      ExcelBtnTPTName: "TPT Trucking Analysis Report",
      seriesRefuel: [
        {
          name: "Diesel (in Ltrs)",
          data: [],
        },
      ],
      chartOptionsRefuel: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Diesel (in Ltrs)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesContainer: [
        {
          name: "Container Executed",
          data: [],
        },
        {
          name: "Total Container Ordered",
          data: [],
        },
      ],
      chartOptionsContainer: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "No. of Containers",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " Containers";
            },
          },
        },
      },

      fieldsV: [
        {
          key: "vehicleTruckId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "regdNo",
          label: "Vehicle No.",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "noOfTripscount",
          label: " No. Of Trips",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "totalDistanceCovered",
          label: "Distance Covered (In Km)",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "sumDieselUsed",
          label: " Diesel Consumed (Ltr's)",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      totalVehicleCount: "",
      availVehicleCount: "",
      bookVehicleCount: "",
      currentPageV: 1,
      perPageV: 5,
      totalRowsV: 0,
      pageOptionsV: [5, 10, 15],
      sortByV: null,
      sortDescV: false,
      sortDirectionV: "desc",
      filterV: null,
      modalInfo: { title: "", content: "" },
      clientMaster: [],
      topTPTClientRevenue: [],
      vehicleReports: [],
      alert: {
        content:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? " Data Updated Succesfully"
            : " Added Succesfully ",
        ok: "ok",
      },
      clientIdFilter: "",
      transportTypeFilter: "",
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      reload: true,

      visible: false,
      //maxDate: moment().format("YYYY-MM-DD"),
      showCal: false,
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      locale: {
        direction: "ltr", //direction of text
        format: "mm/dd/yyyy",
        separator: " - ", //separator between the two ranges
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
      },
      totalRows: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      docURL: URL_BASE_DOC,
      fields: [
        {
          key: "quotationId",
          mainkey: "quotationId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          width: "500px",
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "totalAssignment",
          mainkey: "totalAssignment",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          // table: "P."
        },
        {
          key: "salesSeries",
          mainkey: "salesSeries",
          label: "Execution No.",
          sortable: true,
          sortDirection: "ASC",
          // table: "P."
        },

        {
          key: "fromLocation",
          mainkey: "fromLocation",
          label: " Location",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "totalRequiredContCount",
          mainkey: "totalRequiredContCount",
          label: "Required Container",
          sortable: true,
          sortDirection: "ASC",
          //   table: "D."
        },

        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "ASC",
          //   table: "D."
        },
        {
          key: "vehicleNO",
          mainkey: "vehicleNO",
          label: "Transport By",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRNCount",
          mainkey: "GRNCount",
          label: " GRN No.",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      NoOfAssignment: "",
      isLoading: false,
      showGraph: false,
      showGraphRefuel: false,
      showGraphClientCont: false,
      viewAssignment1: [],
      veiwVehicleBookingForm: [],
      vehicleHistory: [],
      specificTruckId: "",
    };
  },

  filters: {
    moment(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
    DateRangePicker,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fieldsV
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    getSpecificVehicle(ID) {
      this.specificTruckId = ID;
      let view_Assignment = {
        vehicleTruckId: ID,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/getSpecificVehicleReport.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.vehicleHistory.length > 0) {
              this.vehicleHistory = data.vehicleHistory;
              this.$refs["my-modal"].show();
            }
          }
        })
        .catch((error) => {});
    },

    hideModal() {
      this.$refs["my-modal"].hide();
    },
    onFilteredV(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsV = filteredItems.length;
      this.currentPageV = 1;
    },
    filterSearch() {
      this.reload = false;
      this.viewAssignment("0", "1", "1");
    },
    clearDate() {
      //  this.dateRange.startDate=''
      //  this.dateRange.endDate=''
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.transportTypeFilter = "";
      this.dateRange = "";
      this.viewAssignment("0", "1", "1");
    },
    getReports(id, btnName) {
      let excelIdGivin = "";
      if (id == "VR") {
        excelIdGivin = "VR";
      } else if (id == "SingleV") {
        excelIdGivin = "SingleVehicle";
      } else if (id == "GR_TRACKING_REPORT") {
        excelIdGivin = "GR_TRACKING_REPORT";
        this.ExcelBtnName = "Downloading Please Wait...";
      } else {
        excelIdGivin = "TPT";
        this.ExcelBtnTPTName = "Downloading Please Wait...";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        vehicleTruckId: this.specificTruckId,
        dateRange: this.dateRange,
        clientIdFilter: this.clientIdFilter,
        transportTypeFilter: this.transportTypeFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3_test.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                data.excelName;

              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)
            } else {
              this.alert.content = "No Record Found";
              this.$refs["PopDoc"].open();
            }
            if (id == "GR_TRACKING_REPORT") {
              this.ExcelBtnName = btnName;
            } else {
              this.ExcelBtnTPTName = btnName;
            }
          }
        })
        .catch((error) => {});
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewAssignment(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    viewVBookingPage(
      clientId,
      salesid,
      quotationId,
      assignId,
      vBookingId,
      followUpId
    ) {
      this.$sessionsStorage.set("clientId", clientId);
      this.$sessionsStorage.set("salesBookingId", salesid);
      this.$sessionsStorage.set("storeQuotationId", quotationId);
      this.$sessionsStorage.set("storeAssignId", assignId);
      this.$sessionsStorage.set("storeVehicleBookingId", vBookingId);
      if (followUpId == "" || followUpId == null) {
        this.$sessionsStorage.set("storefollowActivityId", "false");
      } else {
        this.$sessionsStorage.set("storefollowActivityId", followUpId);
      }

      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },
    goToTrack(AId) {
      this.$sessionsStorage.set("storeAssignId", AId);
      this.$sessionsStorage.set("backToDetailPage", "22");
      this.$router.push({
        path: "/vehicleQuotation/tranportMailDetails",
      });
    },
    goToMain() {
      this.$router.push({
        path: "/sales/salesBooking",
      });
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    JqueryFun() {
      return $(function () {
        return $("#viewVehicleBooking21212").DataTable();
      });
    },

    viewAssignmentpage(clientId, salesid, quotationId, assignId) {
      this.$sessionsStorage.set("storeAssignId", assignId);
      this.$sessionsStorage.set("clientId", clientId);
      this.$sessionsStorage.set("salesBookingId", salesid);
      this.$sessionsStorage.set("storeQuotationId", quotationId);
      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },

    viewAssignment(CURRENT, SEARCH, pageNumber, clear) {
      this.isLoading = true;
      this.vehicleReports = [];
      let dummyObj = "";
      if (clear == "clear") {
        dummyObj = "";
      } else {
        dummyObj = this.dateRange;
      }

      this.totalRowsV = 0;
      let view_Assignment = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        dateRange: dummyObj,
        clientIdFilter: this.clientIdFilter,
        transportTypeFilter: this.transportTypeFilter,
      };
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/getTransportReports.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.veiwVehicleBookingForm = [];
            if (SEARCH != "2") {
              this.currentPage = 1;
              this.totalRows = data.totalData;
            } else {
              this.currentPage = pageNumber;
            }
            // if (data.Assignment.length > 0) {
            //   this.viewAssignment1 = data.Assignment;
            // }

            if (data.booking.length > 0) {
              this.veiwVehicleBookingForm = data.booking;
            }
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
            }
            if (data.vehicleReports.length > 0) {
              this.vehicleReports = data.vehicleReports;
              this.totalRowsV = data.vehicleReports.length;
              this.totalVehicleCount = data.vehicleReports.length;
              let aryAvail = data.vehicleReports.filter((x) => {
                return x.isTruckMasterActive == "1";
              });

              if (aryAvail.length > 0) {
                this.availVehicleCount = aryAvail.length;
              }
              let aryBook = data.vehicleReports.filter((x) => {
                return x.isTruckMasterActive == "0";
              });

              if (aryBook.length > 0) {
                this.bookVehicleCount = aryBook.length;
              }
            }
            if (data.topTPTClientRevenue.length > 0) {
              this.topTPTClientRevenue = data.topTPTClientRevenue;
              this.showGraph = true;
            } else {
              this.showGraph = false;
              this.topTPTClientRevenue = [];
            }
            if (data.ExecutedTPTClientcontainer.length > 0) {
              for (let p = 0; p < data.ExecutedTPTClientcontainer.length; p++) {
                this.chartOptionsContainer.xaxis.categories.push(
                  data.ExecutedTPTClientcontainer[p].clientName
                );

                this.seriesContainer[0].data.push(
                  data.ExecutedTPTClientcontainer[p].totalSumContainerExecuted
                );
                this.seriesContainer[1].data.push(
                  data.ExecutedTPTClientcontainer[p].allContainerCount
                );
              }
              this.showGraphClientCont = true;
            } else {
              this.chartOptionsContainer.xaxis.categories = [];
              this.seriesContainer[0].data = [];
              this.seriesContainer[1].data = [];
              this.showGraphClientCont = false;
              console.log(this.chartOptionsContainer.xaxis.categories);
            }
            if (data.topRefuelStation.length > 0) {
              for (let q = 0; q < data.topRefuelStation.length; q++) {
                this.chartOptionsRefuel.xaxis.categories.push(
                  data.topRefuelStation[q].vendorName
                );

                this.seriesRefuel[0].data.push(
                  data.topRefuelStation[q].sumtotalDieselLtrs
                );
              }
              this.showGraphRefuel = true;
            } else {
              this.showGraphRefuel = false;
              this.chartOptionsRefuel.xaxis.categories = [];
              this.seriesRefuel[0].data = [];
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// newTransportationReports.vue?57af52c0